export const getIndicadoresAdmin = (state) => state.indicadoresAdmin.lista
export const getIsCarregandoListaIndicadoresAdmin =
  (state) => state.indicadoresAdmin.isCarregandoLista
export const getIsSavingIndicadoresAdmin = (state) => state.indicadoresAdmin.isSaving
